import React, { HTMLProps, memo } from 'react';
import { Icon, Button } from '../base';
import { SIZE } from '@zmedia/bm-soccer-ui/constants';
import classnames from 'classnames';

export enum BUTTON_TYPE {
    NORMAL = '',
    OUTLINE = 'is-outlined',
}

interface IProps extends HTMLProps<HTMLButtonElement> {
    className?: string;
    classNameIcon?: string;
    onClick?: (evt: any) => any;
    title?: string;
    text?: string;
    icon?: string | React.ReactNode;
    isSize?: SIZE;
    type?: BUTTON_TYPE;
    radius?: number;
    isActive?: boolean;
    uppered?: boolean;
    fullwidth?: boolean;
    outlined?: boolean;
    disabled?: boolean;
    triggerBefore?: React.ReactNode;
    loading?: boolean;
    renderAs?: string;
}

export const IconButton = React.forwardRef((props: IProps, ref) => {
    const {
        title,
        text,
        className = '',
        classNameIcon = '',
        onClick,
        icon,
        type = BUTTON_TYPE.NORMAL,
        isSize,
        isActive = false,
        uppered = false,
        fullwidth = false,
        disabled = false,
        triggerBefore = null,
        loading,
        renderAs,
        outlined,
    } = props;

    return (
        <Button
            className={classnames(className, type, {
                active: isActive,
            })}
            disabled={disabled}
            uppered={uppered}
            fullwidth={fullwidth}
            isSize={isSize}
            domRef={ref}
            onClick={onClick}
            loading={loading}
            renderAs={renderAs}
            outlined={outlined}
            title={title}
            type="button"
        >
            <Icon className={classNameIcon} icon={icon} />
            {text ? <span>{text}</span> : null}
            {triggerBefore}
        </Button>
    );
});

export default memo(IconButton);
